<template>
    <div>
        <statistic-card-horizontal icon="ClockIcon" color="primary"
            :statistic="new Date(dateNow).toLocaleDateString('fa-IR')" :statistic-title="formattedDate" />
    </div>
</template>

<script>
import { BCard } from 'bootstrap-vue';
import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal.vue'
export default {
    name: 'todayDate',
    components: {
        StatisticCardHorizontal,
        BCard,
    },
    data() {
        return {
            formattedDate: null,
        }
    },
    props: {
        dateNow: {
            type: String,
            default: '',
        },
    },
    methods: {
        dateConversion() {
            let initialDate = new Date(this.dateNow);
            let year = initialDate.getFullYear();
            let month = initialDate.getMonth() + 1;
            let day = initialDate.getDate();
            let jalaaliDate = require('jalaali-js').toJalaali(year, month, day);
            let weekDays = ["یکشنبه", "دوشنبه", "سه شنبه", "چهارشنبه", "پنجشنبه", "جمعه", "شنبه"];
            let months = ["فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور", "مهر", "آبان", "آذر", "دی", "بهمن", "اسفند"];
            this.formattedDate = weekDays[initialDate.getDay()] + ' ' + jalaaliDate.jd + ' ' + months[jalaaliDate.jm - 1];
        }
    },
    mounted() {
        this.dateConversion()
    }
}
</script>